export default [
  {
    sectionTitle: 'Your Current Subscriptions',
    ids: [
      [2, 5],
      [6, 11],
      [4, 10],
      15,
      40,
      9,
      21,
      7,
      22,
      12,
      19,
      24,
      8,
      48,
      70,
      16,
      18,
      17,
      99,
      25,
      100,
      41,
      102
    ]
  },
  {
    sectionTitle: 'Newsletters To Add',
    ids: [
      [2, 5],
      [6, 11],
      [4, 10],
      15,
      40,
      9,
      21,
      7,
      22,
      12,
      19,
      24,
      8,
      48,
      70,
      16
    ]
  },
  {
    sectionTitle: 'Alerts',
    ids: [18, 17, 99, 25, 100, 41, 102]
  },
  {
    sectionTitle: 'Permissions',
    ids: [[103, 46], [31, 105]]
  }
];



// WEBPACK FOOTER //
// ./src/views/containers/pages/newsletters/newsletters_preferences/newsletters_preferences_page_data.js